import { render, staticRenderFns } from "./ParameterInsightsWidget.vue?vue&type=template&id=1ad537e8&scoped=true"
import script from "./ParameterInsightsWidget.vue?vue&type=script&lang=js"
export * from "./ParameterInsightsWidget.vue?vue&type=script&lang=js"
import style0 from "./ParameterInsightsWidget.vue?vue&type=style&index=0&id=1ad537e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad537e8",
  null
  
)

export default component.exports